import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { UserCooperativeService } from '../../user/user-cooperative.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AuthCooperativeService {
  constructor(
    private http: HttpClient,
    private userCooperativeService: UserCooperativeService
  ) {}

  login(email: string, password: string): Observable<any> {
    const loginData = { email, password };

    return this.http
      .post(API_URL + '/auth-cooperative-login-check', loginData, { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userCooperativeService.setToken(authToken);
        }),
        map((res: any) => res.body)
      );
  }

  logout(): void {
    this.userCooperativeService.logout();
  }

  forgotPassword(body: any): Observable<any> {
    return this.http.post(API_URL + '/cooperative-resetting-password-request', body);
  }

  validateResetToken(token: string): Observable<any> {
    return this.http.get(
      API_URL + '/cooperative-resetting-password-verify-token/' + token,
      {}
    );
  }

  resetPassword(body: any): Observable<any> {
    return this.http.post(API_URL + '/cooperative-resetting-password-reset', body);
  }

  changePassword(body: any, userId: number): Observable<any> {
    return this.http
      .put(API_URL + '/cooperatives/' + userId + '/change-password', body, {
        observe: 'response',
      })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userCooperativeService.setToken(authToken);
        })
      );
  }

  refreshToken(): Observable<any> {
    return this.http
      .get(API_URL + '/cooperative-refresh-token', { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userCooperativeService.setToken(authToken);
        })
      );
  }
}
